import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { combineBankLines as combineBankLinesMutate } from '../query-api'

interface UseCombineBankLinesProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useCombineBankLines = (props?: UseCombineBankLinesProps) => {
  const { onError, onSuccess } = props || {}

  const {
    mutateAsync: combineBankLines,
    isLoading,
    ...rest
  } = useMutation(combineBankLinesMutate, {
    onSuccess,
    onError,
  })

  return { combineBankLines, isProcessing: isLoading, ...rest }
}
